const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'multi-products';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'multi-products',
  // Productos
  LISTADO_PRODUCTOS: 'list-products',
  ALTA_PRODUCTO: 'add-product',
  DETALLE_PRODUCTO: 'product-detail/:id',
  DETALLE: 'product-detail',
  EDITAR_PRODUCTO: 'product-edit/:id',
  EDITAR: 'product-edit',
  V_PAQUETE: 'view-package',
  EDITAR_PAQUETE: 'edit-package',
  VER_PAQUETE: 'view-package/:productId',
  ALTA_PAQUETE: 'add-package',
  PAQUETE: 'add-package',
  POLIZAS_PRODUCTO: 'product-policies',
  DETALLE_POLIZA_PRODUCTO: 'product-policies/detail/:policyId',
};

export const generateFullModuleRoute = (route: string): string => {
  return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Multiseguros',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-plus',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.ALTA_PRODUCTO),
        title: 'Crear productos',
        activated: true,
      },
      {
        icon: 'pi pi-box',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
        ),
        title: 'Productos',
        activated: true,
      },
      {
        icon: 'pi pi-shield',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.POLIZAS_PRODUCTO),
        title: 'Pólizas',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETALLE_PRODUCTO),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETALLE),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDITAR_PRODUCTO),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDITAR),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.VER_PAQUETE),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.ALTA_PAQUETE),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.DETALLE_POLIZA_PRODUCTO
    ),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.POLIZAS_PRODUCTO
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDITAR_PAQUETE),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_PRODUCTOS
    ),
  },
];

export const CONFIG_LISTADO = {
  LIST_PRODUCTS: 'administrador.multi-products.list-products',
  PRODUCT_POLICIES: 'administrador.multi-products.product-policies',
};

export const TIPO_COTIZACION_LINEAS_COMERCIALES = {
  PESOS: 'UYU',
  DOLARES: 'USD',
  EUROS: 'EUR',
};

export const TIPO_DATO_CAMPO_ALTA_PRODUCTO = {
  ALFANUMERICO: 'Alfanumérico',
  ARCHIVO_ADJUNTO: 'Archivo adjunto',
  IMAGENES: 'Imágenes',
  NUMERICO: 'Numérico',
  GEOLOCALIZACION: 'Geolocalización',
};

export const TIPO_DATO_CAMPO_PRODUCTO = {
  ALFANUMERICO: 'alfanum',
  ARCHIVO_ADJUNTO: 'file',
  IMAGENES: 'img',
  NUMERICO: 'num',
  GEOLOCALIZACION: 'geolocation',
};

export const VISIBILIDAD_CAMPO_ADICIONAL = {
  VISIBLE: 'Visible',
  NO_VISIBLE: 'No visible',
};

export const REQUERIDO_CAMPO_ADICIONAL = {
  REQUERIDO: 'Requerido',
  NO_REQUERIDO: 'No requerido',
};

export const PRODUCT_POLICIES_COLUMNS_NAME = {
  VALIDITY_DATE: 'validityDate',
  VALIDITY_DATE_END: 'validityDateEnd',
  ISSUED_DATE: 'issuedDate',
  ISSUED_STATUS: 'issuedStatus',
  PAYMENT_STATUS: 'paymentStatus',
  POLICY_NUMBER: 'policyNumber',
  PRODUCT_NAME: 'productName',
  PACKAGE_NAME: 'packageName',
  PRICE: 'price',
  PAYMENT_METHOD: 'paymentMethod',
  MODALITY: 'modality',
  MODALITY_STATUS: 'modalityStatus',
  INSURED_NAME: 'insuredName',
  BROKER_NAME: 'brokerName',
  BROKER_CODE: 'brokerCode',
  ACTIONS: 'actions',
  RENEWAL: 'isRenewal',
};

export const ISSUED_STATUS = [
  { name: 'Emitida', value: 'Emitida' },
  { name: 'Fallida', value: 'Fallida' },
  { name: 'Procesando', value: 'Procesando' },
];

export const ISSUED_STATUS_TRANSLATE = {
  Procesando: 'Procesando',
  Emitida: 'Emitida',
  Fallida: 'Fallida',
};

export const PAYMENT_STATUS = [
  { name: 'Fallido', value: 'Fallido' },
  { name: 'Procesado', value: 'Procesado' },
  { name: 'Enviado', value: 'Enviado' },
];

export const PAYMENT_STATUS_TRANSLATE = {
  Fallido: 'Fallido',
  Procesado: 'Procesado',
  Enviado: 'Enviado',
};

export const IVA_VALUES = [
  { name: '22%', value: 'IVA' },
  { name: 'No incluye', value: 'IVA_EXE' },
];

export const DOCUMENT_TYPES = {
  CI: 'CI',
  RUT: 'RUT',
};

export const DOCUMENT_TYPES_OPTIONS = [
  {
    value: DOCUMENT_TYPES.CI,
    name: DOCUMENT_TYPES.CI,
  },
  {
    value: DOCUMENT_TYPES.RUT,
    name: DOCUMENT_TYPES.RUT,
  },
];

export const LIST_ACTIONS = {
  DETAIL: 'DETAIL',
  REPROCESS: 'REPROCESS',
};

export const PORTALES_VISIBILIDAD_CORREDORES = {
  DIRECTO: 'Directo',
  CORREDORES: 'Corredores',
};

export const FILE_TYPES = ['pdf', 'docx', 'doc', 'docm'];

export const IMAGE_TYPES = ['jpg', 'jpeg', 'gif', 'png'];

export const BROKER_SELECTION = {
  ALL_BROKERS: 'Todos los corredores',
  SPECIFY_BROKER: 'Corredor específico',
};

export const INSURED_AMOUNT_TYPES = {
  INPUT: 'Input',
  PERMANENT_VALUE: 'Valor fijo',
  CHECK: 'Check',
  SELECT: 'Select',
};

export const INSURED_AMOUNT_TYPES_MAP = {
  PERMANENT_VALUE: 1,
  SELECT: 2,
  CHECK: 3,
  INPUT: 4,
};

export const PACKAGE_FORM_TYPES = {
  TASA: 'tasa',
  SUMA_ASEGURADA: 'sumaAsegurada',
  MINIMO: 'minimo',
  MAXIMO: 'maximo',
  SUGERIDO: 'sugerido',
  TIPO_SUMA_ASEGURADA: 'tipoSumaAsegurada',
  LISTA_SUMA_ASEGURADA: 'listaSumasAseguradas',
  CHECK: 'check',
  SUMA_ASEGURADA_VISIBLE: 'sumaAseguradaVisible',
  IS_CHECKED: 'isChecked',
  CODIGO_PRODUCTO: 'codigoProducto',
};

export const COVERAGE_TYPE = {
  SELECT: 'select',
  INPUT: 'input',
  CHECK: 'check',
  PERMANENT_VALUE: 'permanentValue',
};

export enum ECoverageType {
  select = 'Multiple',
  input = 'Acotado',
  check = 'Opcional',
  permanentValue = 'Fijo',
}

export const ORIGIN_OPTIONS = [
  { name: 'Nueva póliza', value: 'Nueva póliza' },
  { name: 'Renovación', value: 'Renovación' },
];

export const CURRENCY_OPTIONS = [
  { name: 'USD', value: 'USD' },
  { name: 'UYU', value: 'UYU' },
];

export const MODALITY_OPTIONS = [
  { name: 'Anual', value: 'annual' },
  { name: 'Suscripción', value: 'subscription' },
];

export const MODALITY_MAPPING_OPTIONS = [
  { name: 'Anual', value: 'Anual' },
  { name: 'Suscripción', value: 'Subscripciones' },
];

export enum EModality {
  ANUAL = 'Anual',
  SUBSCRIPCION = 'Suscripción',
}

export const MODALITY_STATUS_OPTIONS = [
  { name: 'Activa', value: 'activa' },
  { name: 'Cancelada', value: 'cancelada' },
  { name: 'Pendiente', value: 'pendiente' },
  { name: 'Expirada', value: 'expirada' },
  { name: 'Vigente', value: 'vigente' },
];

export const ORIGIN_VALUES = {
  NEW_POLICY: 'Nueva póliza',
  RENEWED: 'Renovación',
};

export const PACKAGE_NAME_MAX_LENGTH = 50;
